<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" app clipped v-if="isAuthenticated">
      <v-list dense nav>
        <v-list-item dense :to="{name: 'Dashboard'}">
          <v-list-item-action>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>ダッシュボード</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list dense nav>
        <v-subheader>購読管理</v-subheader>
        <template v-for="(nav_list, index) in nav_sub_lists">
          <v-list-item
            v-if="!nav_list.lists"
            :to="nav_list.to"
            :key="index"
          >
            <v-list-item-action>
              <v-icon>{{ nav_list.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ nav_list.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group
            v-else
            :prepend-icon=nav_list.icon
            color="primary"
            no-action
            :key="index"
          >
            <template v-slot:activator>
              <v-list-item-title>{{ nav_list.name }}</v-list-item-title>
            </template>
            <v-list-item
              v-for="(list, sub_index) in nav_list.lists"
              :to=list.to
              :key="sub_index"
            >
              <v-list-item-content>
                <v-list-item-title>{{ list.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>

      <v-divider></v-divider>

      <v-list dense nav>
        <v-subheader>広告管理</v-subheader>
        <template v-for="(nav_list, index) in nav_ad_lists">
          <v-list-item
            v-if="!nav_list.lists"
            :to="nav_list.to"
            :key="index"
          >
            <v-list-item-action>
              <v-icon>{{ nav_list.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ nav_list.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group
            v-else
            :prepend-icon=nav_list.icon
            color="primary"
            no-action
            :key="index"
          >
            <template v-slot:activator>
              <v-list-item-title>{{ nav_list.name }}</v-list-item-title>
            </template>
            <v-list-item
              v-for="(list, sub_index) in nav_list.lists"
              :to=list.to
              :key="sub_index"
            >
              <v-list-item-content>
                <v-list-item-title>{{ list.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn block @click="logout">ログアウト</v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <v-app-bar app dense clipped-left color="blue darken-2 white--text" v-if="isAuthenticated">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" color="white"></v-app-bar-nav-icon>
      <v-toolbar-title>購読者DB</v-toolbar-title>
    </v-app-bar>
    <v-content transition="slide-x-transition">
      <router-view></router-view>
    </v-content>
    <v-snackbar
      v-model="snackbar.isActive"
      :color="snackbar.type"
      :timeout=100000
    >
      {{ snackbar.message }}
        <v-btn
          dark
          text
          color="white"
          @click="closeSnackbar"
        >
          Close
        </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      drawer: null,
      nav_sub_lists: [
        {
          name: '見積書',
          icon: 'mdi-text-box',
          to: {name: 'QuotationList'},
        },
        {
          name: '購読管理',
          icon: 'mdi-account-plus',
          to: {name: 'SubscriptionList'},
        },
        {
          name: '請求管理',
          icon: 'mdi-cash-multiple',
          to: {name: 'Invoice'}
        },
        {
          name: '配送管理',
          icon: 'mdi-email-send',
          to: '',
          lists: [
            {
              name: '一括作成', to: {name: 'BulkDelivery'},
            },
            {
              name: '配送データ一覧', to: {name: 'DeliveryList'},
            },
          ]
        },
        {
          name: 'Webアカウント',
          icon: 'mdi-account',
          to: {name: 'WebAccountList'},
        },
        {
          name: 'マスター管理',
          icon: 'mdi-database-edit',
          to: '',
          lists: [
            {
              name: '顧客', to: {name: 'ClientList'},
            },
            {
              name: '送付先', to: {name: 'AddressList'},
            },
            {
              name: 'Webメディア', to: {name: 'WebMediaList'},
            },
            {
              name: '配送製品', to: {name: 'DeliveryItemList'},
            },
            {
              name: '商品', to: {name: 'ProductList'},
            },
          ]
        },
      ],
      nav_ad_lists: [
        {
          name: '見積書',
          icon: 'mdi-text-box',
          to: {name: 'AdsQuotationList'},
        },
        {
          name: '請求書',
          icon: 'mdi-text-box-check',
          to: {name: 'AdsInvoiceList'},
        },
        {
          name: '納品書',
          icon: 'mdi-text-box-check-outline',
          to: {name: 'AdsDeliveryList'},
        },
      ],
    };
  },
  //created() {
  //  this.$store.dispatch('getMasters');
  //  this.$store.dispatch('getProductCategories');
  //  this.$store.dispatch('getDeliveryItemCategories');
  //},
  computed: {
      isAuthenticated() {
          return this.$store.getters.isAuthenticated;
      },
      snackbar() {
        return this.$store.getters.snackbar;
      },
  },
  methods: {
    logout() {
      this.$store.dispatch('userLogout');
    },
    closeSnackbar() {
      this.$store.dispatch('closeSnackbar');
    },
  }
};
</script>
